// libraries.
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// selector.
import { TaskItem } from '@domains/documents-review/interfaces/interfaces';
import { CountryCode } from '@domains/country';
import { getSelectedTask } from '@domains/documents-review/store/slices/document-review-slice';

// slices.
import { setLeadDetailData } from '@domains/lead-detail/store/slices/lead-detail-slice';
import { useGetTaskDetailQuery } from '@domains/documents-review/store/api-slices/task-detail.endpoints';
import { useGetLeadDetailInfoQuery } from '@domains/lead-detail';
import { useGetNidPriceAvailabilityQuery } from '@domains/nid-price-availability';

// components.
import { PriceAvailabilityBanner } from '@shared/PriceAvailabilityBanner/PriceAvailabilityBanner';

// utils.
import { formatPrice } from '@shared/utils';
import { leadDetailDataMX } from '@domains/lead-detail/utils/leadDetailData';

const CUSTOM_FIELDS_FOR_SELLERS_MX = 'ask_price_mx';

export const DataSellersMX = () => {
  const dispatch = useDispatch();
  const detailTask = useSelector(getSelectedTask) as TaskItem;

  const { data, isFetching } = useGetTaskDetailQuery({
    country: CountryCode.MX,
    nid: detailTask?.nid,
    customFields: CUSTOM_FIELDS_FOR_SELLERS_MX,
  });

  const { data: leadDetail, isFetching: fetching } = useGetLeadDetailInfoQuery({
    country: CountryCode.MX,
    nid: detailTask?.nid,
  });

  const { data: nidPriceAvailability } = useGetNidPriceAvailabilityQuery({
    nid: detailTask?.nid,
    country: CountryCode.MX,
  });

  const NO_VALUE = 'No tiene';
  const address = data?.direccion || NO_VALUE;
  const askPrice = formatPrice(data?.ask_price_mx);
  const pricingInicial = formatPrice(
    leadDetail?.pricing_records?.initial_pricing[0]?.price
  );
  const dataCorrecta = data?.data_correcta || NO_VALUE;

  useEffect(() => {
    if (leadDetail) {
      dispatch(setLeadDetailData(leadDetailDataMX(leadDetail, detailTask)));
    }
  }, [dispatch, leadDetail]);

  if (isFetching || fetching) return <div>Cargando información...</div>;

  return (
    <>
      <span>|</span>
      <div>Dirección: {address}</div>
      <span>|</span>
      <div>Ask price: {askPrice}</div>
      <span>|</span>
      <div>Precio pricing inicial: {pricingInicial}</div>
      <span>|</span>
      <div>Data correcta: {dataCorrecta}</div>
      {nidPriceAvailability && (
        <div className="lote-id-warning-pilot">
          <PriceAvailabilityBanner
            currentState={nidPriceAvailability.current_state}
            isAvailablePrice={nidPriceAvailability.is_available_price}
            inline
          />
        </div>
      )}
    </>
  );
};
